<template>
  <main>
    <h3 class="my-0 p-2 header">已选影像</h3>
    <PaymentList :list="billItems"/>
    <van-submit-bar
      :price="price"
      :loading="loading"
      button-text="去支付"
      @submit="handleCreatePayBill"
    />
  </main>
</template>

<script>
import PaymentList from './components/PaymentList.vue';

export default {
  name: 'Payment',
  components: {
    PaymentList,
  },
  data() {
    return {
      price: 0,
      billItems: [],
      loading: false,
      mybillcode: '',
    };
  },
  activated() {
    if (this.$route.query.type) {
      // 补坑, 电子胶片和名医的billcode行为不一致, 不要乱改
      // 可能从名医进来, 也可能从订单进来
      this.mybillcode = sessionStorage.getItem('my_bill_code');
      this.MYhandleCreatePayBill(this.mybillcode);
    } else if (this.$route.query.billCode.slice(0, 2) === 'MY') {
      this.MYhandleCreatePayBill(this.$route.query.billCode);
    } else {
      this.mybillcode = this.$route.query.billCode;
      this.handleLoad();
    }
  },
  methods: {
    // 名医看片调用的create-pay-bill
    async MYhandleCreatePayBill(code) {
      this.loading = true;
      const response = await this.$http
        .post('/cloud-film-api/webapi/order/create-pay-bill', {
          order_code: code,
        })
        .catch(() => {
          this.loading = false;
        });
      const billCode = response.bill_code;
      this.handleGetPrepay(billCode);
    },
    async handleLoad() {
      const response = await this.$http.get('/cloud-film-api/webapi/bill/get-bill', {
        bill_code: this.$route.query.billCode,
      });
      this.price = response.total_bill_price;
      this.billItems = response.bill_items;
    },
    async handleCreatePayBill() {
      this.loading = true;
      const response = await this.$http
        .post('/cloud-film-api/webapi/bill/create-pay-bill', {
          bill_code: this.$route.query.billCode,
        })
        .catch(() => {
          this.loading = false;
        });
      const billCode = response.bill_code;
      this.handleGetPrepay(billCode);
    },
    async handleGetPrepay(billCode) {
      const accessToken = localStorage.getItem('accessToken');
      const response = await this.$http
        .get('/payment-api/webapi/pay/weixin/mp/get-prepay', {
          bill_code: billCode,
          access_token: accessToken,
        })
        .catch(() => {
          this.loading = false;
        });
      this.handleWeChatPayment(response);
    },
    handleWeChatPayment(params) {
      this.loading = false;
      /* eslint-disable no-undef */
      wx.error((res) => {
        this.$toast.fail(res);
      });
      wx.config({
        debug: process.env.NODE_ENV !== 'production',
        appId: params.appId,
        timestamp: params.timeStamp,
        nonceStr: params.nonceStr,
        signature: params.signature,
        jsApiList: ['chooseWXPay'],
      });
      wx.ready(() => {
        const self = this;
        wx.chooseWXPay({
          timestamp: params.timeStamp,
          nonceStr: params.nonceStr,
          package: params.package,
          signType: params.signType,
          paySign: params.paySign,
          success() {
            self.$toast.success('支付成功');
            // path: '/account/order/:id'
            self.$router.push({ name: 'verify', params: { id: self.mybillcode } });
            // window.location.href = `/cloud-film/account/order/${this.$route.query.billCode}`;
          },
          fail() {
            self.$toast.fail('支付失败');
            self.$router.push({ name: 'order-detail', params: { id: self.mybillcode } });
            // window.location.href = `/cloud-film/account/order/${this.$route.query.billCode}`;
          },
          cancel() {
            self.$toast.fail('支付取消');
            self.$router.push({ name: 'order-detail', params: { id: self.mybillcode } });
          },
        });
      });
    },
  },
};
</script>

<style scoped>
.header {
  background-color: #fff;
  font-weight: 400;
  font-size: 1rem;
  border-bottom: solid 1px #ddd;
}
</style>
